var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useRef } from 'react';
import { t } from 'frontend/js/modules/infra/i18n';
import { containerApp } from '../../../../../main';
import iosBridge from '../../../../../app/iosBridge/iosBridgeService';
var toBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = reject;
    });
};
export var useImageUpload = function (options) {
    var _a = options !== null && options !== void 0 ? options : {}, accept = _a.accept, maxSize = _a.maxSize, onChange = _a.onChange, onError = _a.onError;
    var onChangeRef = useRef(onChange);
    var onErrorRef = useRef(onError);
    var optionsRef = useRef({ accept: accept, maxSize: maxSize });
    useEffect(function () {
        onChangeRef.current = onChange;
        onErrorRef.current = onError;
        optionsRef.current = { accept: accept, maxSize: maxSize };
    }, [onChange, onError, accept, maxSize]);
    // Setup for IOS bridge, to show appropriate image picker
    useEffect(function () {
        if (!containerApp.isActive() || !iosBridge.isInitialized() || !(options === null || options === void 0 ? void 0 : options.bridgeConfig)) {
            return;
        }
        var handleImageSuccess = function (response) {
            var _a, _b, _c;
            var _d = response || {}, base64 = _d.base64, name = _d.name, type = _d.type, size = _d.size;
            if (!base64) {
                (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, [{ message: t('engage:image_upload.failed_to_process') }]);
                return;
            }
            var errors = [];
            var currentOptions = optionsRef.current;
            if (currentOptions.accept && type && !currentOptions.accept.includes(type)) {
                errors.push({
                    message: t('engage:image_upload.invalid_file_type', {
                        types: currentOptions.accept.map(function (thing) { return thing.split('/')[1]; }).join(', '),
                    }),
                });
            }
            if (currentOptions.maxSize && size && size > currentOptions.maxSize) {
                errors.push({
                    message: t('engage:image_upload.file_size_exceeds', {
                        size: Math.round(currentOptions.maxSize / 1024 / 1024),
                    }),
                });
            }
            if (errors.length > 0) {
                (_b = onErrorRef.current) === null || _b === void 0 ? void 0 : _b.call(onErrorRef, errors);
                return;
            }
            (_c = onChangeRef.current) === null || _c === void 0 ? void 0 : _c.call(onChangeRef, {
                base64: base64,
                name: name,
                type: type,
                size: size,
            });
        };
        iosBridge.registerHandler(options.bridgeConfig.nativeResponseEvent, handleImageSuccess);
    }, [options === null || options === void 0 ? void 0 : options.bridgeConfig]);
    var handleFileSelection = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var errors, base64, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errors = [];
                    if (!file)
                        return [2 /*return*/];
                    if (accept && !accept.includes(file.type)) {
                        errors.push({
                            message: t('engage:image_upload.invalid_file_type', {
                                types: accept.map(function (type) { return type.split('/')[1]; }).join(', '),
                            }),
                        });
                    }
                    if (maxSize && file.size > maxSize) {
                        errors.push({
                            message: t('engage:image_upload.file_size_exceeds', {
                                size: Math.round(maxSize / 1024 / 1024),
                            }),
                        });
                    }
                    if (errors.length > 0) {
                        onError === null || onError === void 0 ? void 0 : onError(errors);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, toBase64(file)];
                case 2:
                    base64 = _b.sent();
                    onChange === null || onChange === void 0 ? void 0 : onChange({
                        base64: base64,
                        name: file.name,
                        type: file.type,
                        size: file.size,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    onError === null || onError === void 0 ? void 0 : onError([{ message: t('engage:image_upload.failed_to_read') }]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var selectImage = useCallback(function () {
        var _a;
        // IOS bridge specific setup
        if (containerApp.isActive() && iosBridge.isInitialized() && (options === null || options === void 0 ? void 0 : options.bridgeConfig)) {
            var bridgeData = {
                accept: (accept === null || accept === void 0 ? void 0 : accept.join(',')) || '',
                maxSize: maxSize || undefined,
            };
            iosBridge.callHandler(options.bridgeConfig.nativeCallEvent, bridgeData);
            return;
        }
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = (_a = accept === null || accept === void 0 ? void 0 : accept.join(',')) !== null && _a !== void 0 ? _a : '';
        input.style.display = 'none';
        if (options === null || options === void 0 ? void 0 : options.automationId)
            input.setAttribute('data-automation-id', options.automationId);
        var handleChange = function () {
            var _a;
            var file = (_a = input.files) === null || _a === void 0 ? void 0 : _a[0];
            handleFileSelection(file).finally(function () {
                document.body.removeChild(input);
            });
        };
        input.addEventListener('change', handleChange, { once: true });
        document.body.appendChild(input);
        input.click();
    }, [accept, maxSize, onChange, onError, options === null || options === void 0 ? void 0 : options.bridgeConfig]);
    var clearImage = useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        onError === null || onError === void 0 ? void 0 : onError([]);
    }, [onChange, onError]);
    return {
        selectImage: selectImage,
        clearImage: clearImage,
    };
};
